import React from 'react';
import { StoreProvider } from './QuickFilterDataSet';
import QuickFilterMenu from './QuickFilterMenu';
export default props => (React.createElement(StoreProvider, Object.assign({}, props),
    React.createElement(QuickFilterMenu, null)));
